import * as React from "react";
import {translate} from "react-i18next";
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";
import Button from "../Button";
import Dialog from "./Dialog";

interface IModeltypeBasicViewProps extends ITranslatedComponent {
    title: React.ReactNode;
    onDelete?(): void;
    onCancel(): void;
}

class DeleteConfirmDialog extends React.Component<IModeltypeBasicViewProps> {
    render() {
        // show dialog to confirm the delete
        const {t, title, onDelete, onCancel} = this.props;
        let actions =
            [
                onDelete ? <Button key={1} icon={"delete"} label={t("DELETE")} onClick={onDelete} id="delete-submit-button" /> : <></>,
                <Button key={2} icon={"ban"} label={t("CANCEL")} onClick={onCancel} />,
            ];
        return (
            <Dialog
                title={title}
                open={true}
                actions={actions}
                fullWidth={false}
            >
                {this.props.children}
            </Dialog>
        );
    }
}
export default translate("GLOBAL")(DeleteConfirmDialog);



// WEBPACK FOOTER //
// ./src/components/Dialogs/DeleteConfirmDialog.tsx